/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull odys-catalog'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/implementation/odys-catalog)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'catalogueproductionodys';

export const ApiKey: Record<Environment, string> = {
  catalogueproductionodys: '1e75f13ca37004ae5409d3adeb0eda9e'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'odys-catalog',
    versionId: '7c4c9710-7b04-40b7-8ab0-10ca68f570c2'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  },
  serverZone: amplitude.Types.ServerZone.EU
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * Nom de l'agence du viewer. Le tracking plan ne comporte pas d'agency_name : le nom d'agence va dans company, comme côté Odys. Absent pour un DMC.
   */
  company?: string;
  /**
   * Catégorie d'appareil déduite de la largeur du viewport, seuil 770px repris de apps/odys pour que la valeur ait la même signification dans les deux sources.
   */
  device_category: string;
  /**
   * DMC auxquels le viewer a accès (allowedDmcIds). Vide pour une Agency, une ou plusieurs valeurs pour un DMC.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  dmc_ids: string[];
  /**
   * Email du compte identifié. Redondant avec user_id par construction, conservé pour rester aligné sur la taxonomie du projet Odys - Production.
   */
  user_email: string;
  /**
   * Identifiant de l'utilisateur identifié dans le catalogue. Vaut l'email du compte, seul identifiant stable partagé entre le catalogue et Odys.
   */
  user_id: string;
  /**
   * Rôle du viewer dans le catalogue. Tableau pour rester aligné sur la taxonomie Odys, même si le catalogue n'attribue qu'un rôle à la fois. Un Visitor n'est jamais identifié, donc jamais présent ici.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  user_roles: string[];
}

export interface AccessBlockedPageViewedProperties {
  /**
   * raison du blocage, déduite de la page rendue, parmi account_pending | access_denied | forbidden.
   */
  block_reason: string;
}

export interface BriefStepCompletedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
  /**
   * index de l'étape qui vient d'être validée. Clé du funnel de décrochage.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  step_index: number;
}

export interface BriefSubmittedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
}

export interface CartLineRemovedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
}

export interface CartRequestSubmittedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
  /**
   * nombre de lignes contenues dans la demande envoyée. Donne le panier moyen.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  line_count: number;
}

export interface CatalogNavigationClickedProperties {
  /**
   * Identifiant stable de l'élément de navigation cliqué. Vocabulaire fermé en snake_case. Clé du KPI « quelle entrée est utilisée pour entrer dans le catalogue ».
   */
  nav_item: string;
  /**
   * Catégorie du produit consulté, valeur de l'enum ProductCategory. Clé du KPI « répartition des vues de détail par catégorie produit ».
   */
  product_category?: string;
  /**
   * Surface d'où part le clic. Donne la part de navigation mobile via la valeur mobile_drawer.
   */
  trigger_context: string;
}

export interface CatalogSearchResultClickedProperties {
  /**
   * nature du résultat cliqué, parmi destination | dmc.
   */
  result_type: string;
}

export interface CatalogSearchSubmittedProperties {
  /**
   * nombre d'itinéraires affichés après application des filtres courants. La valeur 0 identifie les listes vides.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  result_count: number;
}

export interface DestinationFilterAppliedProperties {
  /**
   * slug de la destination dont la liste de DMC est filtrée, tel qu'il apparaît en URL.
   */
  destination_slug: string;
  /**
   * contrôle manipulé sur la liste des projets, parmi search | status | destination | reset.
   */
  filter_type: string;
}

export interface DestinationViewedProperties {
  /**
   * Slug de la destination consultée, tel qu'il apparaît en URL (par exemple kenya ou costa-rica). Clé de breakdown du KPI « destinations les plus vues ».
   */
  destination_slug: string;
}

export interface DmcContactSubmittedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
}

export interface DmcViewedProperties {
  /**
   * Identifiant du DMC propriétaire du produit consulté. Permet de segmenter l'étape finale du funnel par DMC.
   */
  dmc_id: string;
  /**
   * Raison sociale du DMC, uniquement comme libellé lisible dans les charts. Ne jamais l'utiliser comme clé d'agrégation, elle change si le DMC est renommé.
   */
  dmc_name?: string;
}

export interface ItineraryFilterAppliedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
  /**
   * contrôle manipulé sur la liste des projets, parmi search | status | destination | reset.
   */
  filter_type: string;
}

export interface ItineraryListViewedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
  /**
   * nombre d'itinéraires affichés après application des filtres courants. La valeur 0 identifie les listes vides.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  result_count: number;
}

export interface ItineraryOpenedProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
  /**
   * identifiant de l'itinéraire ouvert. Identifiant opaque, aucun libellé n'est poussé.
   */
  itinerary_id: string;
}

export interface PendingBookingsViewedProperties {
  /**
   * nombre de réservations en attente affichées pour l'agence. La valeur 0 correspond à l'état vide.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  booking_count: number;
}

export interface ProductAddedToCartProperties {
  /**
   * identifiant du DMC propriétaire de l'itinéraire ouvert.
   */
  dmc_id: string;
  /**
   * catégorie du produit ajouté, valeur de l'enum ProductCategory.
   */
  product_category: string;
  /**
   * externalId du produit ajouté, tel qu'il apparaît en URL.
   */
  product_id: string;
}

export interface ProductListViewedProperties {
  /**
   * Identifiant du DMC propriétaire du produit consulté. Permet de segmenter l'étape finale du funnel par DMC.
   */
  dmc_id: string;
  /**
   * Catégorie du produit consulté, valeur de l'enum ProductCategory. Clé du KPI « répartition des vues de détail par catégorie produit ».
   */
  product_category: string;
}

export interface ProductViewedProperties {
  /**
   * Identifiant du DMC propriétaire du produit consulté. Permet de segmenter l'étape finale du funnel par DMC.
   */
  dmc_id: string;
  /**
   * Catégorie du produit consulté, valeur de l'enum ProductCategory. Clé du KPI « répartition des vues de détail par catégorie produit ».
   */
  product_category: string;
  /**
   * externalId du produit, tel qu'il apparaît en URL. Identifiant opaque : le libellé produit se résout côté catalogue, on ne pousse volontairement pas de product_title (haute cardinalité, non requis par les KPIs).
   */
  product_id: string;
}

export interface ProjectDocumentAddedProperties {
  /**
   * type de document voyageur ajouté, correspondant au champ d'upload utilisé.
   */
  document_type: string;
}

export interface ProjectListFilteredProperties {
  /**
   * contrôle manipulé sur la liste des projets, parmi search | status | destination | reset.
   */
  filter_type: string;
}

export interface ProjectOpenedProperties {
  /**
   * statut du projet ouvert, tel qu'affiché sur la carte. Vocabulaire métier en FR, source de vérité Notion.
   */
  project_status: string;
}

export interface ProjectTabViewedProperties {
  /**
   * onglet du détail projet consulté, parmi propositions | services | documents | roadbook.
   */
  tab_name: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AccessBlockedPageViewed implements BaseEvent {
  event_type = 'Access Blocked Page Viewed';

  constructor(
    public event_properties: AccessBlockedPageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BookingModificationRequested implements BaseEvent {
  event_type = 'Booking Modification Requested';
}

export class BriefStepCompleted implements BaseEvent {
  event_type = 'Brief Step Completed';

  constructor(
    public event_properties: BriefStepCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BriefSubmitted implements BaseEvent {
  event_type = 'Brief Submitted';

  constructor(
    public event_properties: BriefSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartLineRemoved implements BaseEvent {
  event_type = 'Cart Line Removed';

  constructor(
    public event_properties: CartLineRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CartRequestSubmitted implements BaseEvent {
  event_type = 'Cart Request Submitted';

  constructor(
    public event_properties: CartRequestSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CatalogHomeViewed implements BaseEvent {
  event_type = 'Catalog Home Viewed';
}

export class CatalogNavigationClicked implements BaseEvent {
  event_type = 'Catalog Navigation Clicked';

  constructor(
    public event_properties: CatalogNavigationClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CatalogSearchResultClicked implements BaseEvent {
  event_type = 'Catalog Search Result Clicked';

  constructor(
    public event_properties: CatalogSearchResultClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CatalogSearchSubmitted implements BaseEvent {
  event_type = 'Catalog Search Submitted';

  constructor(
    public event_properties: CatalogSearchSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContactFormSubmitted implements BaseEvent {
  event_type = 'Contact Form Submitted';
}

export class DestinationFilterApplied implements BaseEvent {
  event_type = 'Destination Filter Applied';

  constructor(
    public event_properties: DestinationFilterAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DestinationViewed implements BaseEvent {
  event_type = 'Destination Viewed';

  constructor(
    public event_properties: DestinationViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DmcContactSubmitted implements BaseEvent {
  event_type = 'DMC Contact Submitted';

  constructor(
    public event_properties: DmcContactSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DmcViewed implements BaseEvent {
  event_type = 'DMC Viewed';

  constructor(
    public event_properties: DmcViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ItineraryFilterApplied implements BaseEvent {
  event_type = 'Itinerary Filter Applied';

  constructor(
    public event_properties: ItineraryFilterAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ItineraryListViewed implements BaseEvent {
  event_type = 'Itinerary List Viewed';

  constructor(
    public event_properties: ItineraryListViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ItineraryOpened implements BaseEvent {
  event_type = 'Itinerary Opened';

  constructor(
    public event_properties: ItineraryOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PendingBookingsViewed implements BaseEvent {
  event_type = 'Pending Bookings Viewed';

  constructor(
    public event_properties: PendingBookingsViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductAddedToCart implements BaseEvent {
  event_type = 'Product Added To Cart';

  constructor(
    public event_properties: ProductAddedToCartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductListViewed implements BaseEvent {
  event_type = 'Product List Viewed';

  constructor(
    public event_properties: ProductListViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProductViewed implements BaseEvent {
  event_type = 'Product Viewed';

  constructor(
    public event_properties: ProductViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProjectDocumentAdded implements BaseEvent {
  event_type = 'Project Document Added';

  constructor(
    public event_properties: ProjectDocumentAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProjectListFiltered implements BaseEvent {
  event_type = 'Project List Filtered';

  constructor(
    public event_properties: ProjectListFilteredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProjectOpened implements BaseEvent {
  event_type = 'Project Opened';

  constructor(
    public event_properties: ProjectOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProjectTabViewed implements BaseEvent {
  event_type = 'Project Tab Viewed';

  constructor(
    public event_properties: ProjectTabViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SignUpSubmitted implements BaseEvent {
  event_type = 'Sign Up Submitted';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Access Blocked Page Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Access%20Blocked%20Page%20Viewed)
   *
   * Une page de blocage d'accès a été affichée. Les trois pages concernées partagent le même ErrorPageLayout et sont modélisées en UN SEUL event discriminé par block_reason plutôt qu'en trois events : c'est le même objet métier, un mur d'accès, vu sous trois raisons. Le volume de la raison account_pending est le signal direct de la latence de validation des comptes, un utilisateur qui revient plusieurs fois sur cette page étant un compte en attente qui s'impatiente.
   *
   * @param properties The event's properties (e.g. block_reason)
   * @param options Amplitude event options.
   */
  accessBlockedPageViewed(
    properties: AccessBlockedPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccessBlockedPageViewed(properties), options);
  }

  /**
   * Booking Modification Requested
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Booking%20Modification%20Requested)
   *
   * Une demande de modification de réservation a été envoyée depuis le détail projet. Signal de friction sur les réservations déjà confirmées : un volume élevé indique soit des réservations mal cadrées en amont, soit un besoin d'édition en autonomie non couvert par le produit. Aucune propriété n'est nécessaire pour répondre à ce KPI de volume.
   *
   * @param options Amplitude event options.
   */
  bookingModificationRequested(
    options?: EventOptions,
  ) {
    return this.track(new BookingModificationRequested(), options);
  }

  /**
   * Brief Step Completed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Brief%20Step%20Completed)
   *
   * Une étape du formulaire de brief a été validée et l'agence est passée à la suivante. Cet event n'est pas un fractionnement artificiel de l'envoi du brief : sur un formulaire aussi long, le taux de décrochage par étape est le seul moyen d'identifier l'étape qui coûte des conversions, information qu'un unique event de soumission ne peut structurellement pas donner. Couplé à Brief Submitted, il produit un funnel complet étape par étape.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  briefStepCompleted(
    properties: BriefStepCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BriefStepCompleted(properties), options);
  }

  /**
   * Brief Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Brief%20Submitted)
   *
   * Le brief a été envoyé au DMC. Aboutissement du parcours de brief et l'un des deux modes de prise de contact qualifiée du Catalogue, l'autre étant le formulaire de contact DMC. Le rapport entre les deux dit si les agences préfèrent un brief structuré ou une question libre.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  briefSubmitted(
    properties: BriefSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BriefSubmitted(properties), options);
  }

  /**
   * Cart Line Removed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Cart%20Line%20Removed)
   *
   * Une ligne a été retirée du panier par l'agence, après confirmation dans le dialogue dédié. Seul signal d'édition du panier, donc seul moyen de distinguer une hésitation ou une erreur d'ajout d'un simple abandon silencieux. Utile pour interpréter un écart entre volume d'ajouts et volume de demandes envoyées.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  cartLineRemoved(
    properties: CartLineRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartLineRemoved(properties), options);
  }

  /**
   * Cart Request Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Cart%20Request%20Submitted)
   *
   * L'agence a envoyé sa demande de réservation au DMC depuis /cart. C'est l'event de conversion terminal du Catalogue, celui qui ferme le funnel ouvert par Catalog Home Viewed. Il est émis pour toute soumission acceptée, y compris quand une partie des lignes échoue (data.failed > 0) : conformément aux règles de tracking on ne dédouble pas l'action en succès et en échec, on mesure que la demande a été envoyée. Le détail des échecs de ligne relève du monitoring applicatif, pas du plan produit.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  cartRequestSubmitted(
    properties: CartRequestSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CartRequestSubmitted(properties), options);
  }

  /**
   * Catalog Home Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Catalog%20Home%20Viewed)
   *
   * Vue de la home du Catalogue (`/`), point d'entrée du funnel de découverte. Choix de taxonomie : les 5 surfaces de consultation sont modélisées en events NOMMÉS DISTINCTS plutôt qu'en un event unique porteur d'un `page_type`, pour trois raisons. (1) Le funnel home → destination → DMC → liste produits → détail produit se construit en glisser-déposer, sans filtre de propriété à chaque étape. (2) Chaque surface ne porte que les identifiants qui existent réellement chez elle, au lieu d'un sac de propriétés vides à 80%. (3) Le tracking plan Amplitude peut rendre `destination_slug` ou `product_id` REQUIS sur l'event concerné, ce qui est impossible avec un event unique où tout devient optionnel. Cet event complète `[Amplitude] Page Viewed` (autocapture `pageViews` déjà actif) qui ne connaît que l'URL. Ici aucune propriété n'est nécessaire : la distinction des deux variantes (`AgencyHomepage` vs `VisitorHomepage`) et la segmentation par rôle se lisent depuis les user properties déjà envoyées par `identify`.
   *
   * @param options Amplitude event options.
   */
  catalogHomeViewed(
    options?: EventOptions,
  ) {
    return this.track(new CatalogHomeViewed(), options);
  }

  /**
   * Catalog Navigation Clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Catalog%20Navigation%20Clicked)
   *
   * Clic sur un élément de navigation du Catalogue. Event indispensable et non substituable : l'autocapture d'interactions d'éléments est volontairement DÉSACTIVÉE dans `AmplitudeTracking.tsx` (`elementInteractions: false`, `formInteractions: false`, pour éviter toute fuite de contenu saisi), donc aucun clic de navigation n'est capté automatiquement. Un SEUL event couvre toute la navigation (navbar, mega-menu Destinations, drawer mobile, switch de catégorie, liens intra-catalogue), discriminée par `nav_item` + `trigger_context`, conformément à la règle « ne pas éclater une action en plusieurs events ». Répond aux trois KPIs navigation : quelles entrées font entrer dans le catalogue (mega-menu vs liens directs vs logo), usage du switch de catégorie sur la liste produits, part de la navigation mobile (drawer). Le clic sur le switch de catégorie émet cet event ET `Product List Viewed` : le premier mesure l'usage du contrôle, le second la vue de surface qui en résulte.
   *
   * @param properties The event's properties (e.g. nav_item)
   * @param options Amplitude event options.
   */
  catalogNavigationClicked(
    properties: CatalogNavigationClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CatalogNavigationClicked(properties), options);
  }

  /**
   * Catalog Search Result Clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Catalog%20Search%20Result%20Clicked)
   *
   * Un résultat de l'autocomplétion de recherche de la home a été cliqué. Couplé à Catalog Search Submitted, donne le taux de clic de la recherche : une recherche très utilisée mais jamais cliquée signale des résultats non pertinents. La propriété result_type distingue les deux natures de résultat que le composant peut retourner, destination ou DMC, ce qui indique ce que les agences cherchent vraiment.
   *
   * @param properties The event's properties (e.g. result_type)
   * @param options Amplitude event options.
   */
  catalogSearchResultClicked(
    properties: CatalogSearchResultClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CatalogSearchResultClicked(properties), options);
  }

  /**
   * Catalog Search Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Catalog%20Search%20Submitted)
   *
   * Une recherche a été effectivement appliquée dans le champ de recherche de la home (HeroSearch), qui interroge à la fois les destinations et les DMC. Mesure l'usage de la recherche comme point d'entrée de la découverte, face à la navigation par mega-menu déjà couverte par Catalog Navigation Clicked. Le texte saisi n'est JAMAIS envoyé : seul le nombre de résultats l'est. C'est un choix délibéré, cohérent avec elementInteractions: false et formInteractions: false dans AmplitudeTracking.tsx, qui existent précisément pour ne jamais laisser fuiter de contenu saisi.
   *
   * @param properties The event's properties (e.g. result_count)
   * @param options Amplitude event options.
   */
  catalogSearchSubmitted(
    properties: CatalogSearchSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CatalogSearchSubmitted(properties), options);
  }

  /**
   * Contact Form Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Contact%20Form%20Submitted)
   *
   * Le formulaire de contact général vers Odys (/contact) a été envoyé. Contrairement au contact DMC, cette page est ouverte à tous les rôles, Visitor inclus, et ne concerne aucun DMC en particulier. Son volume se lit comme un signal de support ou de friction produit. Aucune propriété d'event n'est nécessaire : la segmentation par rôle se lit déjà sur la user property user_roles posée par identify, et le contenu du message ne doit jamais partir dans Amplitude.
   *
   * @param options Amplitude event options.
   */
  contactFormSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new ContactFormSubmitted(), options);
  }

  /**
   * Destination Filter Applied
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Destination%20Filter%20Applied)
   *
   * Un filtre a été appliqué sur la liste des DMC d'une fiche destination (DestinationFilters). Un seul event couvre les 4 contrôles, discriminés par filter_type, plutôt que 4 events distincts : c'est la même action métier (filtrer la liste des DMC) sur des dimensions différentes, exactement le cas où une propriété vaut mieux que plusieurs events. Répond au besoin d'arbitrer quels filtres méritent d'être maintenus. Le texte de recherche n'est pas envoyé, seulement le fait qu'un filtre de type recherche a été appliqué.
   *
   * @param properties The event's properties (e.g. destination_slug)
   * @param options Amplitude event options.
   */
  destinationFilterApplied(
    properties: DestinationFilterAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DestinationFilterApplied(properties), options);
  }

  /**
   * Destination Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Destination%20Viewed)
   *
   * Vue d'une fiche destination (`/destinations/[slug]`), étape 2 du funnel de découverte. Apporte l'identifiant métier de la destination que l'autocapture `[Amplitude] Page Viewed` ne fournit pas (elle ne voit que le path), et alimente directement le KPI « destinations les plus vues » par simple breakdown sur `destination_slug`.
   *
   * @param properties The event's properties (e.g. destination_slug)
   * @param options Amplitude event options.
   */
  destinationViewed(
    properties: DestinationViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DestinationViewed(properties), options);
  }

  /**
   * DMC Contact Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/DMC%20Contact%20Submitted)
   *
   * Une agence a envoyé le formulaire de contact d'un DMC précis depuis /dmcs/[slug]/contact. Mode de prise de contact plus léger que le brief, à comparer à Brief Submitted pour savoir lequel des deux les agences privilégient. Nommé distinctement de Contact Form Submitted car les deux surfaces ne portent pas les mêmes identifiants : seule celle-ci a un dmc_id, ce qui permet de le rendre requis dans le plan Amplitude.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  dmcContactSubmitted(
    properties: DmcContactSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DmcContactSubmitted(properties), options);
  }

  /**
   * DMC Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/DMC%20Viewed)
   *
   * Vue de la fiche / du catalogue d'un DMC réceptif (`/dmcs/[slug]`), étape 3 du funnel de découverte. C'est aussi la page « Mon catalogue » quand le viewer est le DMC lui-même : les auto-consultations s'excluent en filtrant sur la user property `user_roles` (segment rôle = dmc), donc aucune propriété `is_own_catalog` n'est ajoutée. Réutilise le couple `dmc_id` / `dmc_name` déjà établi dans le projet Amplitude `Odys - Production`, pour rester cohérent avec la taxonomie de l'organisation plutôt que d'introduire un `dmc_slug`.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  dmcViewed(
    properties: DmcViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DmcViewed(properties), options);
  }

  /**
   * Itinerary Filter Applied
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Itinerary%20Filter%20Applied)
   *
   * Un contrôle de filtrage ou d'affichage a été manipulé sur la page itinéraires d'un DMC. Un seul event couvre les quatre contrôles, discriminés par filter_type, plutôt que quatre events distincts. ATTENTION au recouvrement : le changement de catégorie via CategorySwitcher, réutilisé par cette page, relève de l'event existant Catalog Navigation Clicked et ne doit PAS être émis ici, sous peine de compter deux fois la même action.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  itineraryFilterApplied(
    properties: ItineraryFilterAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ItineraryFilterApplied(properties), options);
  }

  /**
   * Itinerary List Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Itinerary%20List%20Viewed)
   *
   * La liste des itinéraires d'un DMC a été affichée sur /dmcs/[slug]/itineraries. Complète le funnel de découverte sur une surface que Product List Viewed ne couvre pas : ce dernier est indexé sur product_category et ne connaît donc pas les itinéraires. result_count permet de repérer les DMC dont la page itinéraires s'affiche vide, cas où la page est consultée mais sans contenu à montrer.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  itineraryListViewed(
    properties: ItineraryListViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ItineraryListViewed(properties), options);
  }

  /**
   * Itinerary Opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Itinerary%20Opened)
   *
   * Un itinéraire a été ouvert depuis la liste, en vue cartes ou en vue liste. Mesure la profondeur d'engagement sur les itinéraires : rapporté à Itinerary List Viewed, il donne le taux d'ouverture, indicateur de la pertinence des itinéraires exposés. Symétrique de Product Viewed pour la famille produits.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  itineraryOpened(
    properties: ItineraryOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ItineraryOpened(properties), options);
  }

  /**
   * Pending Bookings Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Pending%20Bookings%20Viewed)
   *
   * La liste des réservations en attente d'une agence a été affichée sur /my-bookings. Seul event de cette surface : les cartes ne sont pas cliquables, il n'y a donc aucune action d'ouverture à mesurer, et l'entrée avec badge relève de Catalog Navigation Clicked. booking_count transforme cet event de vue en mesure de charge opérationnelle : il dit combien de réservations une agence a réellement en attente, et sa valeur 0 signale une entrée mise en avant pour une page vide.
   *
   * @param properties The event's properties (e.g. booking_count)
   * @param options Amplitude event options.
   */
  pendingBookingsViewed(
    properties: PendingBookingsViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PendingBookingsViewed(properties), options);
  }

  /**
   * Product Added To Cart
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Product%20Added%20To%20Cart)
   *
   * Un produit a été ajouté au panier depuis la modale de réservation du détail produit. Première étape commerciale du Catalogue et chaînon manquant du funnel : aujourd'hui la mesure s'arrête à Product Viewed, si bien qu'on ne sait pas quelle proportion des produits consultés suscite un ajout. Les trois propriétés reprennent exactement celles de Product Viewed, ce qui permet de construire le funnel vue vers ajout sans aucune transformation.
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  productAddedToCart(
    properties: ProductAddedToCartProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductAddedToCart(properties), options);
  }

  /**
   * Product List Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Product%20List%20Viewed)
   *
   * Vue d'une liste de produits d'un DMC pour une catégorie donnée (`/dmcs/[slug]/products?category=<category>`), étape 4 du funnel de découverte, sur TOUTES les catégories de l'enum `ProductCategory`. Un seul event couvre les 8 catégories, discriminées par `product_category` : la catégorie est une dimension d'un même objet métier (la liste de produits d'un DMC), pas une surface différente, c'est donc exactement le cas où une propriété vaut mieux que 8 events. Répond au KPI « répartition des vues de liste par catégorie produit ».
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  productListViewed(
    properties: ProductListViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductListViewed(properties), options);
  }

  /**
   * Product Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Product%20Viewed)
   *
   * Vue du détail d'un produit (`/dmcs/[slug]/products/[category]/[externalId]`), étape finale du funnel de découverte, sur TOUTES les catégories (`DETAIL_SUPPORTED_CATEGORIES` couvre l'intégralité de l'enum). Comme pour la liste, un event unique couvre les 8 catégories via `product_category`. Apporte les identifiants métier absents de `[Amplitude] Page Viewed` et répond aux KPIs « produits les plus consultés » et « répartition des vues de détail par catégorie produit ».
   *
   * @param properties The event's properties (e.g. dmc_id)
   * @param options Amplitude event options.
   */
  productViewed(
    properties: ProductViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductViewed(properties), options);
  }

  /**
   * Project Document Added
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Project%20Document%20Added)
   *
   * Un document voyageur a été ajouté à un projet. Event à forte valeur : le document voyageur est la SEULE exception en écriture accordée à une Agency dans le Catalogue, tout le reste étant en lecture seule. Son volume mesure donc l'adoption de la seule capacité d'écriture du produit.
   *
   * @param properties The event's properties (e.g. document_type)
   * @param options Amplitude event options.
   */
  projectDocumentAdded(
    properties: ProjectDocumentAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProjectDocumentAdded(properties), options);
  }

  /**
   * Project List Filtered
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Project%20List%20Filtered)
   *
   * Un filtre a été appliqué sur la liste des projets de l'agence. Un seul event couvre les quatre contrôles, discriminés par filter_type. Permet d'arbitrer quels filtres sont réellement utilisés et donc à maintenir. Le texte recherché n'est jamais transmis, seulement le fait qu'un filtre de type recherche a été appliqué.
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  projectListFiltered(
    properties: ProjectListFilteredProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProjectListFiltered(properties), options);
  }

  /**
   * Project Opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Project%20Opened)
   *
   * Un projet a été ouvert depuis la liste des projets de l'agence. Rapporté aux vues de la liste, donne le taux d'ouverture et donc l'utilité réelle de cette surface dans le Catalogue. project_status permet de savoir quels statuts de projet motivent une consultation, sans pousser la référence du projet qui serait à haute cardinalité et sans valeur analytique agrégée.
   *
   * @param properties The event's properties (e.g. project_status)
   * @param options Amplitude event options.
   */
  projectOpened(
    properties: ProjectOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProjectOpened(properties), options);
  }

  /**
   * Project Tab Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Project%20Tab%20Viewed)
   *
   * Un onglet du détail projet a été consulté. Event indispensable et non substituable : les onglets ne changent pas l'URL, donc ni l'autocapture [Amplitude] Page Viewed ni aucun event de vue de page ne peut dire quelle section du dossier projet est réellement utilisée. C'est la seule mesure possible de la valeur relative des quatre sections.
   *
   * @param properties The event's properties (e.g. tab_name)
   * @param options Amplitude event options.
   */
  projectTabViewed(
    properties: ProjectTabViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProjectTabViewed(properties), options);
  }

  /**
   * Sign Up Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Catalogue%20Production%20-%20Odys/events/main/latest/Sign%20Up%20Submitted)
   *
   * Le formulaire d'inscription du Catalogue a été soumis. Première étape mesurable du parcours d'entrée, à mettre en regard du volume de Access Blocked Page Viewed avec la raison account_pending, qui mesure combien de ces inscriptions restent bloquées en attente de validation. Aucune propriété : le formulaire ne doit rien transmettre de ce que l'utilisateur saisit.
   *
   * @param options Amplitude event options.
   */
  signUpSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new SignUpSubmitted(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
